export enum FocusLinkProduct {
	AtTable = "attable",
	CommandCenter = "commandcenter",
	EGift = "egift",
	Kiosk = "kiosk",
	MobilePay = "mobilepay",
	OnlineOrder = "onlineorder",
	POS = "pos",
	Subscriptions = "subscriptions",
}
